import { Modifier } from '../modifier';
import type { Damage } from '../damage.type';
import { ModifierPriority, ModifierTags, StatusEffect } from '../modifier.type';
import { StatusEffectRegistry } from '../status-effects';

export class Accuracy extends Modifier {
  static readonly baseTitle = 'Accuracy';
  static readonly baseText = 'Attacks deal double damage, then fade.';
  static readonly baseIcon = 'accuracy';
  static readonly baseTags = [ModifierTags.Boon];
  static readonly basePriority = ModifierPriority.Late;

  // Instance properties that can change
  title = Accuracy.baseTitle;
  text = Accuracy.baseText;
  icon = Accuracy.baseIcon;
  tags: Array<ModifierTags> = [...Accuracy.baseTags];
  priority = Accuracy.basePriority;

  damageOut(damage: Damage) {
    if (damage.value > 0) {
      damage.value *= 2;
      this.removeStacks(1);
    }
  }
}

// Register the status effect
StatusEffectRegistry.register(StatusEffect.Accuracy, Accuracy);
